// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/UnileverDesire-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/UnileverDesire-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/UnileverDesire-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/UnileverDesire-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Semi Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Unilever Desire Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: 300;
  font-style: normal;
}
.PageBackground_backgroundLayer__cG9\\+N {
  position: fixed;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
  border-radius: 16px;
  background: linear-gradient(328deg, #006FDE 48.33%, #06C 101.85%), linear-gradient(90deg, #026CCE 0%, #013768 100%);
}

.PageBackground_blurRight__LPDDZ {
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  bottom: -120px;
  filter: blur(100px);
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .PageBackground_blurRight__LPDDZ {
    width: 250px;
    height: 250px;
    bottom: -80px;
    filter: blur(80px);
  }
}

.PageBackground_blurRight__LPDDZ {
  right: -100px;
  background: radial-gradient(circle, rgba(120, 50, 180, 0.5) 0%, transparent 70%);
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .PageBackground_blurRight__LPDDZ {
    right: -60px;
  }
}

.PageBackground_lilacAurora__ypYKG {
  position: absolute;
  width: 1174px;
  height: 831px;
  top: 193px;
  left: -230px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .PageBackground_lilacAurora__ypYKG {
    width: 100vw;
    height: auto;
    top: 30%;
    transform: none;
    bottom: auto;
    left: -80px;
  }
}

.PageBackground_lilacAuroraFullOpacity__Tu6t7 {
  opacity: 1;
}

.PageBackground_lilacAuroraDimmed__Wl1en {
  opacity: 0.63;
}

.PageBackground_ellipesRight__R5Uim {
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components_upgrade/PageBackground/PageBackground.module.scss","webpack://./src/assets/styles/tokens/_radius.scss","webpack://./src/assets/styles/tokens/_sizing.scss","webpack://./src/assets/styles/tokens/_effects.scss"],"names":[],"mappings":"AAIA;EACE,gCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACHF;ADMA;EACE,sCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACJF;ADQA;EACE,wCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACNF;ADUA;EACE,mCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACRF;ADWA;EACE,6CAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACTF;ADYA;EACE,oCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACVF;AA/BA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBCLU;EDMV,mHAAA;AAiCF;;AA1BA;EACE,kBAAA;EACA,YEXa;EFYb,aEZa;EFab,kBCbc;EDcd,cGlBsB;EHmBtB,mBAAA;AA6BF;ADUE;EC7CF;IASI,YEjBW;IFkBX,aElBW;IFmBX,aGvBoB;IHwBpB,kBAAA;EA8BF;AACF;;AA3BA;EACE,aG5BqB;EH6BrB,gFAAA;AA8BF;ADHE;EC7BF;IAKI,YG/BmB;EH8DrB;AACF;;AA5BA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AA+BF;ADhBE;ECpBF;IASI,YAAA;IACA,YAAA;IACA,QAAA;IACA,eAAA;IACA,YAAA;IACA,WAAA;EA+BF;AACF;;AA5BA;EACE,UAAA;AA+BF;;AA5BA;EACE,aGnDsB;AHkFxB;;AA5BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,YAAA;AA+BF","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular\";\n  src: url(\"../fonts/UnileverDesire-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Semi Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular Italic\";\n  src: url(\"../fonts/UnileverDesire-RegularItalic.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Light\";\n  src: url(\"../fonts/UnileverDesire-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n\n\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../assets/styles/abstracts/variables\";\n@import \"../../assets/styles/abstracts/mixins\";\n\n\n.backgroundLayer {\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  overflow: hidden;\n  pointer-events: none;\n  border-radius: $radius-xl;\n  background: linear-gradient(328deg, $color-bg-gradient-start 48.33%, $color-bg-gradient-end 101.85%), linear-gradient(\n              90deg,\n              $color-bg-gradient-secondary-start 0%,\n              $color-bg-gradient-secondary-end 100%\n            );\n}\n\n.blurRight {\n  position: absolute;\n  width: $size-blur-lg;\n  height: $size-blur-lg;\n  border-radius: $radius-circle;\n  bottom: $offset-blur-bottom-lg;\n  filter: blur($blur-lg);\n\n  @include sm {\n    width: $size-blur-sm;\n    height: $size-blur-sm;\n    bottom: $offset-blur-bottom-sm;\n    filter: blur($blur-sm);\n  }\n}\n\n.blurRight {\n  right: $offset-blur-right-lg;\n  background: radial-gradient(circle, $color-blur-purple 0%, transparent 70%);\n\n  @include sm {\n    right: $offset-blur-right-sm;\n  }\n}\n\n.lilacAurora {\n  position: absolute;\n  width: 1174px;\n  height: 831px;\n  top: 193px;\n  left: -230px;\n\n\n  @include sm {\n    width: 100vw;\n    height: auto;\n    top: 30%;\n    transform: none;\n    bottom: auto;\n    left: -80px;\n  }\n}\n\n.lilacAuroraFullOpacity {\n  opacity: 1;\n}\n\n.lilacAuroraDimmed {\n  opacity: $opacity-aurora-dimmed;\n}\n\n.ellipesRight {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  opacity: 0.9;\n}\n\n","\n$radius-xs: 1px;\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-dropdown-country: 9px 8px 0 0;\n$radius-xl: 16px;\n$radius-lg: 24px;\n$radius-full: 40px;\n$radius-pill: 50px;\n$radius-circle: 50%;\n","//width \n\n$size-perfectstore-width: 1332px;\n$size-perfectstore-card-width: 432px;\n$size-perfectstore-card-height: 155px;\n$size-store-icon: 14px;\n$size-colored-box-width: 18px;\n$size-colored-box-height: 16px;\n$size-icon-xxs: 11px;\n$size-blur-lg: 400px;\n$size-blur-sm: 250px;\n\n// Icon sizes\n$size-icon-xs: 16px;\n$size-icon-sm: 20px;\n$size-icon-md: 24px;\n$size-icon-lg: 37px;\n\n// Dropdown sizes\n$size-dropdown-country-width: 219px;\n$size-dropdown-country-height: 229px;\n","// Blur filters\n$blur-lg: 100px;\n$blur-sm: 80px;\n\n// Blur positioning offsets\n$offset-blur-bottom-lg: -120px;\n$offset-blur-bottom-sm: -80px;\n$offset-blur-right-lg: -100px;\n$offset-blur-right-sm: -60px;\n\n// Z-index layers\n$z-index-dropdown-high: 999999;\n$z-index-dropdown-max: 2147483647;\n\n// Opacity states\n$opacity-aurora-dimmed: 0.63;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundLayer": `PageBackground_backgroundLayer__cG9+N`,
	"blurRight": `PageBackground_blurRight__LPDDZ`,
	"lilacAurora": `PageBackground_lilacAurora__ypYKG`,
	"lilacAuroraFullOpacity": `PageBackground_lilacAuroraFullOpacity__Tu6t7`,
	"lilacAuroraDimmed": `PageBackground_lilacAuroraDimmed__Wl1en`,
	"ellipesRight": `PageBackground_ellipesRight__R5Uim`
};
export default ___CSS_LOADER_EXPORT___;
